import { Component, Inject } from '@angular/core'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import {
  MyAccountInfo,
  RootState,
  selectActualReconDate,
  selectFocusedMyAccount,
  selectUserPolicy,
  UserPolicy,
} from '@helios/state-management'
import { Store } from '@ngrx/store'
import { toISOFormat } from '@northfork/basics'
import { ComponentContainer } from 'golden-layout'
import { Subject } from 'rxjs'
import {
  debounceTime,
  distinctUntilChanged,
  take,
  takeUntil,
} from 'rxjs/operators'
import { ReconDashboardKey } from '../panel-key'
import { ReconDashboardStorageService } from './recon-dashboard-storage-service'

@Component({
  selector: 'hs-recon-dashboard',
  templateUrl: './recon-dashboard-panel.component.html',
  styleUrls: ['./recon-dashboard-panel.component.scss'],
})
export class ReconDashboardPanelComponent extends BasePanelComponent {
  panelKey = ReconDashboardKey
  private readonly _destroyed$ = new Subject<void>()
  source = 'helios'
  account?: MyAccountInfo
  reconDate?: string
  initialized = false
  userPolicy?: UserPolicy

  constructor(
    @Inject(LayoutContainer) container: ComponentContainer,
    private readonly store: Store<RootState>,
    private readonly reconDashboardStorageService: ReconDashboardStorageService,
  ) {
    super(container)
  }

  ngOnDestroy(): void {
    this._destroyed$.next()
    this._destroyed$.complete()
  }

  ngOnInit() {
    this.store
      .select(selectActualReconDate)
      .pipe(take(1), takeUntil(this._destroyed$))
      .subscribe((reconDate?: Date) => {
        if (reconDate === undefined) return
        this.reconDate = toISOFormat(reconDate) as string
      })
    this.store
      .select(selectFocusedMyAccount)
      .pipe(
        debounceTime(500),
        takeUntil(this._destroyed$),
        distinctUntilChanged(),
      )
      .subscribe(account => {
        this.account = account
      })

    this.store
      .select(selectUserPolicy)
      .pipe(takeUntil(this._destroyed$), distinctUntilChanged())
      .subscribe(userPolicy => {
        this.userPolicy = userPolicy ?? undefined
      })
  }

  ngAfterViewInit() {
    // Toggle initialized to trigger r2wc to re-read properties including functions
    Promise.resolve().then(() => {
      this.initialized = true
    })
  }

  getUserDashboardConfig = (configId: string): Promise<string | undefined> => {
    return this.reconDashboardStorageService.getUserDashboardConfig(configId)
  }

  putUserDashboardConfig = (
    configId: string,
    config: string,
  ): Promise<void> => {
    return this.reconDashboardStorageService.putUserDashboardConfig(
      configId,
      config,
    )
  }
}
